import {ShowState} from '../../types/Show'
import type {ILabel} from '../../../../types';

export default {
    state(state: ShowState): ILabel {
        if(state === ShowState.ConnectionError) {
            return <ILabel>{
                de: 'Verbindungsproblem, bitte warten',
                en: 'Connection problem Please wait',
                es: 'Problemas de conexión, por favor espere',
                fr: 'Problèmes de connection, merci de patienter un instant',
                nl: 'Verbindingsprobleem, gelieve te wachten',
                it: 'Problemi di connessione, si prega di attendere',
            }
        }
        if(state === ShowState.Init) {
            return <ILabel>{
                de: 'Wird geladen - Bitte warten',
                en: 'Loading - Please wait',
                es: 'Cargando - Por favor, espere',
                fr: 'Chargement, veuillez patienter',
                nl: 'Aan het laden - Even wachten',
                it: 'Caricamento - Si prega di attendere',
            }
        }
        if(state === ShowState.Break) {
            return <ILabel>{
                de: 'Gleich geht es weiter',
                en: 'Next show starts in a few seconds',
                es: 'Enseguida continuamos',
                fr: 'La suite des enchères dans un instant.',
                nl: 'De veiling gaat zo verder',
                it: 'Continueremo tra un momento',
            }
        }
        return <ILabel>{
            de: 'undefined',
            en: 'undefined',
            es: 'undefined',
            fr: 'undefined',
            nl: 'undefined',
            it: 'undefined',
        }
    },
    auctionHelpTitle: <ILabel>{
        de: 'So bieten Sie in 2 Schritten mit:',
        en: 'How to bid in 2 steps:',
        es: 'Cómo hacer una oferta en 2 pasos:',
        fr: 'Comment enchérir en 2 étapes :',
        nl: 'Hoe bieden in 2 stappen:',
        it: 'Come fare un\'offerta in 2 passaggi:',
    },
    auctionHelpStep1: <ILabel>{
        de: 'Gebot abgeben',
        en: 'Place bid',
        es: 'Pujar por esta joya',
        fr: 'Commandez',
        nl: 'Bieden',
        it: 'Invia l\'offerta',
    },
    auctionHelpStep2: <ILabel>{
        de: 'Gebot bestätigen',
        en: 'Confirm bid',
        es: 'Confirmar puja',
        fr: 'Confirmez votre offre',
        nl: 'Bod bevestigen',
        it: 'Conferma l\'offerta',
    }
}